<div class="animated window">
</div>